import { DashboardPageProps } from '../utils/get-dashboard-props';

export const isDashboardPageProps = (obj: any): obj is DashboardPageProps =>
    obj && 'datapageName' in obj && 'dashboardSlug' in obj && 'visualizations' in obj;
